module.exports = __webpack_public_path__ + "img/baymaklife-nedir.2ff138be.jpg";